import { Component, type OnInit, ChangeDetectionStrategy } from '@angular/core';
import type { EnergyBalanceSettings, EnergyBalanceTranslationKeys } from '../../../interfaces/Widget.interface';
import { WidgetSize } from '../../../providers/widgets.contants';
import { EnergyBalanceComponent } from '../../energy-balance/energy-balance';
import { AbstractWidgetClass } from '../AbstractWidget.class';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./widget-energy-balance-by-usage.scss'],
    selector: 'widget-energy-balance-by-usage',
    templateUrl: 'widget-energy-balance-by-usage.html',
    imports: [EnergyBalanceComponent]
})
export class WidgetEnergyBalanceByUsageComponent
    extends AbstractWidgetClass<EnergyBalanceTranslationKeys, EnergyBalanceSettings>
    implements OnInit
{
    size = WidgetSize.HALF;

    ngOnInit() {}
}
